import React from "react"

export interface LoadingProps {
	position?: number
	width?: number
	height: number
}

const Loader: React.FC<LoadingProps> = ({ position, width, height }) => {
	const svgWidth = width ?? "100%"
	const svgPosition = position ?? 60
	return (
		<svg width={svgWidth} height={height} fill="none" role={"svg-loader"}>
			<g id="loader" transform={`translate(675,${svgPosition - 60})`}>
				<rect y="0" width="13" height="50" fill="#6974C1">
					<animate
						attributeName="height"
						values="50;10;50"
						begin="0s"
						dur="1s"
						repeatCount="indefinite"
					/>
					<animate
						attributeName="y"
						values="0;20;0"
						begin="0s"
						dur="1s"
						repeatCount="indefinite"
					/>
				</rect>
				<rect x="19" y="0" width="13" height="50" fill="#BF7FF7">
					<animate
						attributeName="height"
						values="50;10;50"
						begin="0.2s"
						dur="1s"
						repeatCount="indefinite"
					/>
					<animate
						attributeName="y"
						values="0;20;0"
						begin="0.2s"
						dur="1s"
						repeatCount="indefinite"
					/>
				</rect>
				<rect x="38" y="0" width="13" height="50" fill="#76C9FA">
					<animate
						attributeName="height"
						values="50;10;50"
						begin="0.4s"
						dur="1s"
						repeatCount="indefinite"
					/>
					<animate
						attributeName="y"
						values="0;20;0"
						begin="0.4s"
						dur="1s"
						repeatCount="indefinite"
					/>
				</rect>
			</g>
		</svg>
	)
}

export default Loader
